import React, { lazy, Suspense, useEffect, useState } from "react";
import { isMobile } from "../utility/constand";
import "./productusageview.css";
import NumberAndTextShow from "./NumberAndTextShow";
const LottieAnimation = lazy(() => import("./LottieAnimation"));
const LottieAnimationMobile = lazy(() => import("./LottieAnimationMobile"));

function VerificationBackend() {
  const [showMobileLottie, setShowMobileLottie] = useState(false);
  const [wizardIndex, setWizardIndex] = useState(1);
  const [filCircleIndex, setFilCircleIndex] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setShowMobileLottie(true);
    }

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowMobileLottie(true);
      } else {
        setShowMobileLottie(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let timeoutId;

    const interval = setInterval(() => {
      setWizardIndex((prev) => {
        if (prev === 2) {
          setFilCircleIndex(false);
          return 1;
        }

        if (timeoutId) clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          setFilCircleIndex(true);
        }, 2700);

        return prev + 1;
      });
    }, 3540);

    return () => {
      clearInterval(interval);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="product-contain">
      <div className="productusage-container">
        <div className="productusage-wrapper ">
          <div
            className="flexprop "
            style={{
              gap: "3rem",
              flexWrap: "wrap",
              padding: "3vw 0vw",
              position: "relative",
            }}
          >
            {/* <Suspense fallback={<div>...</div>}>
              <Grid
                colors={gridColors}
                speed={15}
                squareSize={80}
                maxLineLength={100}
                lineWidth={0.5}
                gridColor="rgba(255, 255, 255, 0.1)"
                className="ligntning-animation-productusage"
              />
            </Suspense> */}

            <div className="productusage-headings flexprop">
              <div className="productusage-main-heading">
                ID Verification Backed by <span>Real </span>
                Performance
              </div>
              <div className="product-usage-text">
                Trusted by teams across industries, BeFiSc makes digital ID
                verification seamless, delivering certainty, speed, and
                reliability in every workflow.
              </div>
            </div>

            <div
              className="flexprop"
              style={{
                width: "90vw",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-around",
                flexWrap: "wrap",
                gap: "2rem",
                zIndex: "20",
                pointerEvents: "none",
              }}
            >
              <NumberAndTextShow
                bigtext={"150"}
                smalltext={"+"}
                nextrowtext={"APIs"}
              />
              <NumberAndTextShow
                bigtext={"3"}
                smalltext={"sec"}
                nextrowtext={"Avg Response Time"}
              />
              <NumberAndTextShow
                bigtext={"99.99"}
                smalltext={"%"}
                nextrowtext={"Api uptime"}
              />
            </div>
            <div
              // style={{ position: "relative", zIndex: 9999 }}
              className="productusage-headings flexprop"
            >
              <div className="productusage-main-heading">
                Enter Input & <span>Get Verified Data </span>
              </div>
              <div className="product-usage-text">
                Ensure data accuracy with BeFisc. Simply input data and get
                verified results in seconds.
              </div>
              {/* <div>
                <BlueButton
                  text={"Book a Free Demo"}
                  styles={{
                    width: "100%",
                    textWrap: "nowrap",
                    pointerEvents: "auto",
                    backgroundImage:
                      "radial-gradient(circle at 50% 50%, #DFFF8E, #AFF500 91%)",
                    color: "#6D2FEC",
                    size: "1rem",
                    border: "1px solid #A0E100",
                  }}
                  onClick={() => handleScrollToViewPort("book-a-demo")}
                />
                <button
                  className="product-usage-demo-btn"
                  onClick={() => handleScrollToViewPort("book-a-demo")}
                >
                  Book a Free Demo
                </button>
              </div> */}
            </div>
          </div>
          <div className="wizard-statement">
            {/* image */}
            <div className="verification-card-image">
              {/* <img src="/images/How it works IDProof.svg" alt="" /> */}
              <img
                src={
                  showMobileLottie
                    ? "/images/howmobile.svg" // Mobile image
                    : "/images/How it works IDProof.svg" // Desktop image
                }
                alt="How it works"
              />
            </div>
            <div className="wizard">
              <div className="step">
                <div
                  className={`circle ${
                    wizardIndex === 1 || wizardIndex === 2
                      ? "circle-active"
                      : ""
                  }`}
                >
                  1
                </div>
                <p className="step-text">Request user input</p>
                <div
                  style={{ width: "100%" }}
                  className={`wizard-line ${
                    wizardIndex === 1 ? "wizard-line-active" : ""
                  }`}
                ></div>
              </div>
              <div className="step">
                <div
                  className={`circle ${
                    wizardIndex === 2 ? "circle-active" : ""
                  }`}
                >
                  2
                </div>

                <p className="step-text">Get it verified</p>
                <div
                  className={`wizard-line ${
                    wizardIndex === 2 ? "wizard-line-two-active" : ""
                  }`}
                ></div>
              </div>
              <div className="step">
                <div
                  className={`circle ${filCircleIndex ? "circle-active" : ""}`}
                >
                  3
                </div>
                <p className="step-text">Trigger action instantly</p>
              </div>
            </div>
          </div>
          <div className="productusage-container-two">
            <div className="productusage-top-background"></div>
            {!showMobileLottie && (
              <div className="productusage-web-view">
                <Suspense fallback={<div>...</div>}>
                  <LottieAnimation />
                </Suspense>
              </div>
            )}
            {showMobileLottie && (
              <div className="productusage-mobile-view">
                <Suspense fallback={<div>...</div>}>
                  <LottieAnimationMobile />
                </Suspense>
              </div>
            )}
            {/* {LottieAni && (
              <div
                className={`${
                  showMobileLottie
                    ? "productusage-mobile-view"
                    : "productusage-web-view"
                }`}
              >
                <Suspense fallback={<div>...</div>}>
                  <LottieAni />
                </Suspense>
              </div>
            )} */}
          </div>
        </div>
        {/* <img
          src="/images/rectangle-curved-svg.png"
          alt="curved-secton"
          style={{ width: "100%", height: "50%", backgroundColor: "white" }}
          loading="lazy"
          decoding="async"
        /> */}
      </div>
    </div>
  );
}

export default React.memo(VerificationBackend);
